// extracted by mini-css-extract-plugin
export default {"flexSpacer":"_5d7058e9"};